import Cookies from 'js-cookie'
import {
  UPDATE_PHONE_ID,
  SWAP_LANGUAGE,
  FETCH_USER,
  FETCH_OPTIONS,
  FETCH_CUSTOMER_LABELS
} from './constants'
import * as KEYS from '../../constants/keys'

const initialState = {
  preSaleFlag: false,
  currentPhoneId: Cookies.get(KEYS.DEVICE_ID) || null,
  currentPhoneName: 'No Device Selected',
  language: 'en',
  user: {},
  options: {},
  isFetching: true,
  customerLabels: null
}

export default function devicebits(state = initialState, action) {
  switch (action.type) {
    case UPDATE_PHONE_ID: {
      return {
        ...state,
        currentPhoneId: action.phoneId,
        currentPhoneName: action.deviceName
      }
    }
    case SWAP_LANGUAGE: {
      return {
        ...state,
        language: action.language
      }
    }
    case FETCH_USER.SUCCESS: {
      return {
        ...state,
        user: action.user
      }
    }
    case FETCH_OPTIONS.REQUEST: {
      return {
        ...state,
        isFetching: true
      }
    }
    case FETCH_OPTIONS.SUCCESS: {
      return {
        ...state,
        options: action.options
      }
    }
    case FETCH_CUSTOMER_LABELS.REQUEST: {
      return {
        ...state,
        isFetching: true
      }
    }
    case FETCH_CUSTOMER_LABELS.SUCCESS: {
      return {
        ...state,
        customerLabels: action.customerLabels,
        isFetching: false
      }
    }

    default: {
      return state
    }
  }
}
